import React, { memo } from "react";
import Image from "./Image";

function Card( props: {
    imgSrc: string,
    imgAlt: string,
    title?: string,
    description?: string,
    fullImage?: boolean,
    children?: any,
    textNormal?: boolean,
} ) {
    return (
        <div className={ `transition-all duration-200 flex ${props.textNormal ? '' : 'text-center items-center ' } flex-col gap-5 w-full bg-white shadow-xl hover:border-gray-600 hover:scale-110 ${ props.fullImage ? 'p-0' : 'p-3' } border-2 rounded-xl` }>
            <Image
                className={ ` ${ props.fullImage ?  'w-full rounded-xl h-[267.083px] md:h-[194.267px]' : 'w-1/2 md:w-3/4 lg:w-full'} ` }
                src={ props.imgSrc }
                alt={ props.imgAlt }
            />
            { props.children ? props.children : (
                <article className={ `${ props.fullImage ? 'p-3' : 'p-0' }` }>

                    <h3 className={ `text-3xl font-light` }>{ props.title }</h3>
                    <p>{ props.description }</p>
                </article>
            )
            }

        </div>
    )
}

export default memo( Card )